module.exports = __webpack_public_path__ + "static/media/HT.2383a3f1.wav";